import React, { useState } from "react";
import { ImageIcon, Wand2 } from "lucide-react";

const STYLES = ["Photorealistic", "Digital art", "3D render", "Watercolor", "Neon / cyberpunk", "Minimal line art"];
const RATIOS = ["Square", "Wide 16:9", "Portrait 9:16"];

export default function ImageStudio({ onGenerate, disabled }) {
  const [prompt, setPrompt] = useState("");
  const [style, setStyle] = useState(null);
  const [ratio, setRatio] = useState("Square");

  const submit = () => {
    if (!prompt.trim() || disabled) return;
    let full = prompt.trim();
    if (style) full += `. Art style: ${style}.`;
    if (ratio && ratio !== "Square") full += ` Aspect ratio: ${ratio}.`;
    onGenerate(full);
    setPrompt("");
  };

  return (
    <div className="px-4 pb-5 pt-2" data-testid="image-generator-studio">
      <div className="mx-auto max-w-3xl">
        <div className="flex flex-wrap gap-2 mb-2.5">
          {STYLES.map((s) => (
            <button
              key={s}
              onClick={() => setStyle(style === s ? null : s)}
              data-testid={`style-${s.replace(/\s+/g, "-").toLowerCase()}`}
              className={`rounded-full px-3 py-1.5 text-xs font-medium border ${style === s ? "bg-[#1A73E8] text-white border-[#1A73E8]" : "bg-white text-[#5F5F5B] border-[#E6E6DF] hover:border-[#CECEBE]"}`}
              style={{ transition: "background-color 0.2s ease, border-color 0.2s ease" }}
            >
              {s}
            </button>
          ))}
        </div>
        <div className="flex flex-wrap gap-2 mb-3">
          {RATIOS.map((r) => (
            <button
              key={r}
              onClick={() => setRatio(r)}
              data-testid={`ratio-${r.replace(/[\s:]+/g, "-").toLowerCase()}`}
              className={`rounded-full px-3 py-1.5 text-xs font-medium border ${ratio === r ? "bg-[#EAF3FB] text-[#174EA6] border-[#AECBFA]" : "bg-white text-[#5F5F5B] border-[#E6E6DF] hover:border-[#CECEBE]"}`}
              style={{ transition: "background-color 0.2s ease, border-color 0.2s ease" }}
            >
              {r}
            </button>
          ))}
        </div>

        <div className="rounded-3xl border border-[#E6E6DF] bg-white shadow-[0_2px_20px_rgba(23,23,22,0.05)] p-2.5 focus-within:border-[#CECEBE]" style={{ transition: "border-color 0.2s ease" }}>
          <div className="flex items-center gap-2 px-2">
            <ImageIcon className="h-5 w-5 text-[#1A73E8] shrink-0" />
            <input
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && submit()}
              placeholder="Describe the image you want to create…"
              data-testid="image-prompt-input"
              className="flex-1 bg-transparent py-2 text-[15px] placeholder:text-[#8C8C85] focus:outline-none"
            />
            <button
              onClick={submit}
              disabled={disabled || !prompt.trim()}
              data-testid="generate-image-button"
              className="flex items-center gap-2 rounded-full bg-[#1A73E8] text-white px-4 py-2 text-sm font-medium disabled:opacity-30 disabled:cursor-not-allowed hover:bg-[#155cba]"
              style={{ transition: "background-color 0.2s ease, opacity 0.2s ease" }}
            >
              <Wand2 className="h-4 w-4" /> Generate
            </button>
          </div>
        </div>
        <p className="mt-2 text-center text-[11px] text-[#8C8C85]">Powered by Gemini image generation.</p>
      </div>
    </div>
  );
}
